import DefaultPage from '../default-page';


class ErrorPage extends DefaultPage {

}


export default ErrorPage;
